import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrimaryContactLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 23.8124,
			cy: 21.977,
			r: 5.5992,
			stroke: "#A8AAE3",
			strokeWidth: 1.41666,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.2839 33L21.1266 39.9575C21.0455 40.4455 21.1589 40.9457 21.4426 41.3509L22.4516 42.7919C23.2033 43.8654 24.793 43.866 25.5454 42.793L26.5308 41.3878C26.8302 40.9609 26.9398 40.4292 26.8337 39.9188L25.395 33",
			stroke: "#A8AAE3",
			strokeWidth: 1.41666,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.9513 1.87505C24.8758 0.792138 23.1242 0.792137 22.0488 1.87505L3.9676 20.0816C2.89785 21.1588 2.29749 22.6153 2.29749 24.1334V46.7356C2.29749 47.1498 2.63327 47.4856 3.04749 47.4856H7.05888C7.47309 47.4856 7.80888 47.1498 7.80888 46.7356C7.80888 46.3214 7.47309 45.9856 7.05888 45.9856H3.79749V24.1334C3.79749 23.0113 4.24123 21.9347 5.03192 21.1386L23.1131 2.93204C23.6019 2.43981 24.3981 2.43981 24.887 2.93204L42.9681 21.1386C43.7588 21.9347 44.2026 23.0113 44.2026 24.1334V28.8357H45.7026V24.1334C45.7026 22.6153 45.1022 21.1588 44.0324 20.0816L25.9513 1.87505Z",
			fill: "currentColor",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 30.5619H28.5346C29.209 30.5619 29.8614 30.6562 30.4793 30.8322C31.0157 30.443 31.6372 30.1638 32.3106 30.0279C31.173 29.4629 29.8909 29.1453 28.5346 29.1453H18.5C13.8056 29.1453 10 32.9508 10 37.6452V45.673C10 46.7162 10.8457 47.5618 11.8889 47.5618H31.189C30.5096 47.2318 29.9212 46.7436 29.4717 46.1452H11.8889C11.6281 46.1452 11.4167 45.9338 11.4167 45.673V37.6452C11.4167 33.7332 14.588 30.5619 18.5 30.5619Z",
			fill: "currentColor",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.5 31.9688C34.8926 31.9688 31.9688 34.8926 31.9688 38.5C31.9688 42.1074 34.8926 45.0312 38.5 45.0312C42.1074 45.0312 45.0312 42.1074 45.0312 38.5C45.0312 34.8926 42.1074 31.9688 38.5 31.9688ZM30.7812 38.5C30.7812 34.2368 34.2368 30.7812 38.5 30.7812C42.7632 30.7812 46.2187 34.2368 46.2187 38.5C46.2187 42.7632 42.7632 46.2187 38.5 46.2187C34.2368 46.2187 30.7812 42.7632 30.7812 38.5ZM36.1482 37.3834C36.1482 36.438 36.9144 35.6704 37.8611 35.6704H37.9062V35.3194C37.9062 34.9915 38.1721 34.7257 38.5 34.7257C38.8279 34.7257 39.0938 34.9915 39.0938 35.3194V35.6704H39.9393C40.2672 35.6704 40.5331 35.9362 40.5331 36.2642C40.5331 36.5921 40.2672 36.8579 39.9393 36.8579H38.5645C38.5433 36.8602 38.5218 36.8614 38.5 36.8614C38.4782 36.8614 38.4567 36.8602 38.4355 36.8579H37.8611C37.5708 36.8579 37.3357 37.0933 37.3357 37.3834C37.3357 37.6735 37.5708 37.9088 37.8611 37.9088H39.1398C40.0865 37.9088 40.8528 38.6764 40.8528 39.6218C40.8528 40.5682 40.0863 41.3347 39.1398 41.3347H39.0938V41.6804C39.0938 42.0083 38.8279 42.2741 38.5 42.2741C38.1721 42.2741 37.9062 42.0083 37.9062 41.6804V41.3347H37.0616C36.7337 41.3347 36.4679 41.0689 36.4679 40.741C36.4679 40.4131 36.7337 40.1472 37.0616 40.1472H38.4805C38.4869 40.147 38.4935 40.1469 38.5 40.1469C38.5065 40.1469 38.5131 40.147 38.5195 40.1472H39.1398C39.4304 40.1472 39.6653 39.9124 39.6653 39.6218C39.6653 39.3316 39.4301 39.0963 39.1398 39.0963H37.8611C36.9144 39.0963 36.1482 38.3288 36.1482 37.3834Z",
			fill: "#A8AAE3"
		})
	]
});
export default SvgPrimaryContactLight;
